import React, {Component} from "react";
import axios from "axios";
import {Popover, OverlayTrigger} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./ContactForm.scss";

export default class ContactForm extends Component {
    state = {
        name: "",
        email: "",
        message: "",
        agreement: false,
        errors: {
            name: "",
            email: "",
            message: "",
            agreement: ""
        }
    };
    resetForm = () => {
        if (window && document) {
            document.getElementById("contact-form").reset();
            this.setState({
                name: "",
                email: "",
                message: "",
                agreement: false
            });
        }
    };

    async sendData(url, formData) {
        const {sentMessages} = this.props;
        await axios.post(url, formData).then((response) => {
            if (window && document) {
                const confirmMessageBox = document.getElementById("confirmMsg");
                const errorMessageBox = document.getElementById("errorMsg");
                if (response.status === 200) {
                    confirmMessageBox.style.display = "block";
                    confirmMessageBox.innerText = `${sentMessages.success}`;
                } else if (response.status === 500) {
                    errorMessageBox.style.display = "block";
                    errorMessageBox.innerText = `${sentMessages.serverError}`;
                } else if (response.status === 400) {
                    errorMessageBox.style.display = "block";
                    errorMessageBox.innerText = `${sentMessages.formError}`;
                } else {
                    errorMessageBox.style.display = "block";
                    errorMessageBox.innerText = `${sentMessages.error}`;
                }
            }
        }).catch((error) => {
            alert(error);
        });
        this.resetForm();
    }

    formValid = ({errors, ...rest}) => {
        let valid = true;
        Object.values(errors).forEach(val => {
            if (val.length > 0) {
                valid = false;
            }
        });
        Object.values(rest).forEach(val => {
            if (val === "" || val === false) {
                valid = false;
            }
        });
        Object.keys(rest).map(key => this.setErrorsValue(key, rest[key]));
        return valid;
    };
    onFormSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", this.state.name);
        formData.append("email", this.state.email);
        formData.append("message", this.state.message);
        if (this.formValid(this.state)) {
            this.sendData(`/mail.php`, formData);
        }
    };

    handleInputs = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState({
            [name]: value
        });
        this.setErrorsValue(name, value);
    };
    setErrorsValue = (name, value) => {
        const {validateErrors} = this.props;

        const emailPattern = /^([a-z]|[A-Z]|[0-9]|[.+_-])+@(([a-z]|[A-Z]|[0-9])+\.([a-z]|[A-Z]|[0-9]){2,3})$/;
        let formErrors = this.state.errors;
        switch (name) {
            case "name":
                formErrors.name = value.length === 0 ? `${validateErrors.required}` : "";
                break;
            case "email":
                formErrors.email = value.match(emailPattern) ? "" : `${validateErrors.email}`;
                break;
            case "message":
                formErrors.message = value.length === 0 ? `${validateErrors.required}` : "";
                break;
            case "agreement":
                formErrors.agreement = value === true ? "" : `${validateErrors.agreement}`;
                break;
            default:
                break;
        }
        this.setState({
            formErrors, [name]: value
        });
    };

    render() {
        const {name, emailPlaceholder, messagePlaceholder, btnText, rodo} = this.props;
        const createRodoText = () => {
            return {__html: rodo.agreement};
        };
        return (
            <div className="form-wrapper">
                <form id="contact-form" method="post" onSubmit={this.onFormSubmit} noValidate>
                    <div>
                        <input
                            id="firstName"
                            type="text"
                            name="name"
                            onChange={this.handleInputs}
                            value={this.state.value}
                            placeholder={name}
                        />
                        <p className="validate-error">{this.state.errors.name}</p>
                    </div>
                    <div className="email-box">
                        <input
                            id="email"
                            type="email"
                            name="email"
                            onChange={this.handleInputs}
                            value={this.state.value}
                            placeholder={emailPlaceholder}
                        />
                        <p className="validate-error">{this.state.errors.email}</p>
                    </div>
                    <div>
                    <textarea
                        id="message"
                        name="message"
                        onChange={this.handleInputs}
                        value={this.state.value}
                        placeholder={messagePlaceholder}
                    >
                    </textarea>
                        <p className="validate-error">{this.state.errors.message}</p>
                    </div>
                    <div className="checkbox-wrap">
                        <div className="checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    id="agreement"
                                    name="agreement"
                                    onChange={this.handleInputs}
                                />
                                <span className="cr"><i className="cr-icon fa fa-check"/></span>
                                <span className='agreement-text'>
                                    {rodo.checkbox}
                                </span>

                            </label>
                            <OverlayTrigger
                                trigger="hover"
                                placement='top'
                                overlay={
                                    <Popover id={`popover-top`}>
                                        <p dangerouslySetInnerHTML={createRodoText()}/>
                                    </Popover>
                                }
                            >
                                <FontAwesomeIcon className='rodo-icon icon-white' icon="info-circle"/>
                            </OverlayTrigger>
                        </div>
                        <p className="validate-error">{this.state.errors.agreement}</p>
                    </div>
                    <button type="submit">{btnText}</button>
                </form>
                <p id="confirmMsg" className="response-box success"/>
                <p id="errorMsg" className="response-box error"/>
            </div>
        );
    }
}
